import { forwardRef } from 'react';
import Box, { BoxProps } from '@mui/material/Box';
import { useForkRef, useTheme } from '@mui/material';
import useScrollPagination from '../views/hooks/useScrollPagination';

interface DSBoxProps extends BoxProps {
  isFetchingNextPage?: boolean;
  fetchNextPage?: () => void;
  hasNextPage?: boolean;
}

const DSBox = forwardRef<HTMLDivElement, DSBoxProps>((props, ref) => {
  const { isFetchingNextPage, fetchNextPage, hasNextPage, ...boxProps } = props;
  const { spacing, palette } = useTheme();

  const shouldUsePagination =
    fetchNextPage &&
    hasNextPage !== undefined &&
    isFetchingNextPage !== undefined;

  const { scrollRef } = shouldUsePagination
    ? useScrollPagination({
        fetchNextPage: fetchNextPage!,
        isFetchingNextPage: isFetchingNextPage!,
        hasNextPage: hasNextPage!,
      })
    : { scrollRef: null };

  const mergedRef = useForkRef(ref, scrollRef);

  return (
    <Box
      ref={mergedRef}
      {...boxProps}
      sx={{
        '&::-webkit-scrollbar': {
          width: spacing(1),
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: palette.action.selected,
          borderRadius: spacing(8),
        },
        '&::-webkit-scrollbar-track': {
          backgroundColor: 'transparent',
        },
        ...boxProps.sx,
      }}
    />
  );
});

export default DSBox;
